export const LOGIN_PAGE = 'login';
export const MEDIDATION_LIST = 'page-meditation/list';
export const MEDIDATION_CREATE = 'page-meditation/create';
export const MEDIDATION_EDIT = 'page-meditation/edit';
export const MEDIDATION_CATEGORY_LIST = 'page-meditation/category-list';
export const MEDIDATION_CATEGORY_CREATE = 'page-meditation/category-create';
export const MEDIDATION_CATEGORY_EDIT = 'page-meditation/category-edit';
export const AFFIRMATION_LIST = 'page-affirmation/list';
export const AFFIRMATION_CREATE = 'page-affirmation/create';
export const AFFIRMATION_EDIT = 'page-affirmation/edit';
export const BREATHING_LIST = 'page-breathing/list';
export const BREATHING_CREATE = 'page-breathing/create';
export const BREATHING_EDIT = 'page-breathing/edit';

export const SLEEP_STORY_LIST = 'page-sleep-story/list';
export const SLEEP_STORY_CREATE = 'page-sleep-story/create';
export const SLEEP_STORY_EDIT = 'page-sleep-story/edit';

export const SLEEP_STORY_CATEGORY_LIST = 'page-sleep-story-categories/list';
export const SLEEP_STORY_CATEGORY_CREATE = 'page-sleep-story-category/create';
export const SLEEP_STORY_CATEGORY_EDIT = 'page-sleep-story-category/edit';

export const MUSIC_LIST = 'page-music/list';
export const MUSIC_CREATE = 'page-music/create';
export const MUSIC_EDIT = 'page-music/edit';
export const MUSIC_CATEGORY_LIST = 'page-music/category-list';
export const MUSIC_CATEGORY_CREATE = 'page-music/category-create';
export const MUSIC_CATEGORY_EDIT = 'page-music/category-edit';

export const MUSIC_NATURE_SOUND_LIST = 'page-music/nature-sound-list';
export const MUSIC_NATURE_SOUND_CREATE = 'page-music/nature-sound-create';
export const MUSIC_NATURE_SOUND_EDIT = 'page-music/nature-sound-edit';

export const MUSIC_NATURE_SOUND_MIX_LIST = 'page-music/nature-sound-mix-list';
export const MUSIC_NATURE_SOUND_MIX_CREATE = 'page-music/nature-sound-mix-create';
export const MUSIC_NATURE_SOUND_MIX_EDIT = 'page-music/nature-sound-mix-edit';

export const USER_LIST = 'page-user/list';
export const PROMOCODE_LIST = 'page-promocode/list';
export const PROMOCODE_CREATE = 'page-promocode/create';
export const PROMOCODE_EDIT = 'page-promocode/edit';
export const EMAIL_PUSH_LIST = 'page-email-push/list';
export const EMAIL_PUSH_CREATE = 'page-email-push/create';
export const EMAIL_PUSH_EDIT = 'page-email-push/edit';
export const INSPIRATION_LIST = 'page-inspiration/list';
export const INSPIRATION_CREATE = 'page-inspiration/create';
export const INSPIRATION_EDIT = 'page-inspiration/edit';
export const REMINDER_LIST = 'page-reminder/list';
export const REMINDER_CREATE = 'page-reminder/create';
export const REMINDER_EDIT = 'page-reminder/edit';
export const PROFILE = 'page-profile';
export const ANIMATION_LIST = 'page-animation/list';
export const ANIMATION_CREATE = 'page-animation/create';
export const ANIMATION_EDIT = 'page-animation/edit';
export const LANGUAGES_LIST = 'page-language/list';
export const DOCUMENTS = 'page-documents/list';
export const DOCUMENTS_EDIT = 'page-documents/edit';
export const STATISTICS = 'statistics';

export const LEVEL_LIST = 'page-level/list';
export const LEVEL_CREATE = 'page-level/create';
export const LEVEL_EDIT = 'page-level/edit';

export const REWARD_LIST = 'page-reward/list';
export const REWARD_CREATE = 'page-reward/create';
export const REWARD_EDIT = 'page-reward/edit';